<template>
  <div class="view player">
    <video-player :video-id="videoId"/>
  </div>
</template>

<script>
  import VideoPlayer from '@/components/VideoPlayer.vue';

  export default {
    components: { VideoPlayer },
    props: {
      videoId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        routeBefore: '',
      };
    },
    methods: {
      setShowExpiration(val) {
        this.$store.dispatch('settings/setShowExpiration', val);
      },
    },
    mounted() {
      try {
        if (VK_0) {
          const btnClose = document.getElementById('buttonClose');
          if (btnClose.parentNode) {
            btnClose.parentNode.removeChild(btnClose);
          }
        }
      } catch (error) {
        // Empty block to detect when we are not on vewd TV
      }
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => vm.routeBefore = from.name ? from.name : null);
    },
    beforeRouteLeave(to, from, next) {
      this.setShowExpiration(false);
      next();
    },
  };
</script>

<style scoped lang="scss">
  @mixin transition($transition...) {
    -moz-transition: $transition;
    -o-transition: $transition;
    -webkit-transition: $transition;
    transition: $transition;
  }

  .player {
    position: absolute;
    width: 100%;
    height: 100%;
    background: black;
  }
</style>
